import takeRequest from '~/store/takeRequest';

import { accessByCostumer } from './actions';

export function* accesByCustomerSaga() {
  yield takeRequest(accessByCostumer);
}
